import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {ExportComponent} from './export-component';

export const ExportComponentModule: string = ng
  .module('export-component', [
    'ui.bootstrap',
    uiRouter
  ])
  .component('exportComponent', ExportComponent)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/component/export-component/export-component.module.ts